import { render, staticRenderFns } from "./MarkExamForm.vue?vue&type=template&id=2f4a0b92&scoped=true"
import script from "./MarkExamForm.vue?vue&type=script&lang=js"
export * from "./MarkExamForm.vue?vue&type=script&lang=js"
import style0 from "./MarkExamForm.vue?vue&type=style&index=0&id=2f4a0b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a0b92",
  null
  
)

export default component.exports